import React, { useMemo, useState } from 'react'
import type { Item } from './Sidebar'
import { useAppTranslations } from '../../../utils/hooks/useAppTranslations'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import MenuWithIcon from '../MenuWithIcon'
import { Status } from '../../../__generated__/graphql'
import { FormDialog } from '../FormDialog'
import { CreateAdGroupInCampaign } from '../../../pages/adgroup/create/CreateAdgroup'
import { Add } from '@mui/icons-material'

export const SidebarAdvertiserActions: React.FC<{
  item: Item
  updateSidebarItems: () => void
}> = ({ item }) => {
  const t = useAppTranslations()
  const [createAdgroupDialogOpened, setCreateAdgroupDialogOpened] = useState(false)

  const actionsItems = useMemo(() => {
    if (item.status === Status.Archived) return []

    return [
      {
        text: t('layout.sidebar.advertiser.createAdgroup'),
        icon: <Add fontSize="small" />,
        action: () => setCreateAdgroupDialogOpened(true),
        autoClose: true,
      },
    ]
  }, [item, t])

  return (
    <>
      <MenuWithIcon
        actionItems={actionsItems}
        dataId="sidebarMenuItemIcon"
        size="small"
        iconButtonSx={{ py: 0, color: 'white' }}
      >
        <MoreVertIcon fontSize="small" />
      </MenuWithIcon>
      {/* stop propagation to avoid triggering parent ListItemButton link redirection */}
      <div onClick={(e) => e.stopPropagation()}>
        <FormDialog title={t('adgroup.create')} open={createAdgroupDialogOpened} setOpen={setCreateAdgroupDialogOpened}>
          <CreateAdGroupInCampaign setOpen={setCreateAdgroupDialogOpened} campaignId={item.id} />
        </FormDialog>
      </div>
    </>
  )
}

export default SidebarAdvertiserActions
